import { Resources } from 'constants/resources';

import { AxiosResponse, AxiosError } from 'axios';
import { axios } from 'config/axios';

export const startRecalculation = async (taskId: string): Promise<void> => {
  return axios
    .post(`${Resources.CommissionRecalculationTasks}/${taskId}/start`, {})
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};
